import * as React from 'react';
import {
  Icon,
  IconButton as CkIconButton,
  IconButtonProps,
} from '@chakra-ui/react';

type IconButtonProptypes = {
  ariaLabel: string;
  icon: React.ElementType;
  size?: 'sm' | 'md' | 'lg';
} & Omit<IconButtonProps, 'aria-label' | 'size' | 'children'>;

const IconButton: React.FC<IconButtonProptypes> = ({
  ariaLabel,
  icon,
  size = 'md',
  ...props
}) => {
  return (
    <CkIconButton
      size={size}
      _hover={{ bg: 'lightPrimary', borderRadius: 'lg' }}
      bg="none"
      aria-label={ariaLabel}
      {...props}
    >
      <Icon
        className="icon"
        as={icon}
        w={size === 'md' ? 10 : size === 'lg' ? 12 : 2.5}
        h={size === 'md' ? 10 : size === 'lg' ? 12 : 2.5}
      />
    </CkIconButton>
  );
};

export default IconButton;
